import { AppPushState } from '../../../data/AppPushState';

export class BaseTrigger {
	_interval = -1;
	_maxLimitCount = -1;
	_thresholdCountStart = -1;

	constructor(interval: number, maxLimitCount: number, thresholdCountStart: number) {
		this._interval = interval;
		this._maxLimitCount = maxLimitCount;
		this._thresholdCountStart = thresholdCountStart;
	}

	get interval() {
		return this._interval;
	}

	get maxLimitCount() {
		return this._maxLimitCount;
	}

	get thresholdCountStart() {
		return this._thresholdCountStart;
	}

	isQualifiedForPush(appPushState: AppPushState): boolean {
		const triggeredCount = appPushState.triggeredCount;
		const executedCount = appPushState.executedCount;
		if (
			this._isMinimumThresholdReached(triggeredCount) &&
			this._hasNotReachedMaxLimit(executedCount) &&
			this._isIntervalMatching(triggeredCount)
		) {
			return true;
		}
		return false;
	}

	private _isMinimumThresholdReached(triggerCount: number) {
		return triggerCount >= this.thresholdCountStart;
	}

	private _hasNotReachedMaxLimit(executedCount: number) {
		return executedCount < this.maxLimitCount;
	}

	private _isIntervalMatching(triggerCount: number) {
		if (this.interval === triggerCount || triggerCount % this.interval === 0) {
			return true;
		}
		return false;
	}
}
